import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    FlightDeparturesExportExcelParams,
    FlightDeparturesExportExcelResponse,
    GetFlightDeparturesParams,
    GetFlightDeparturesResponse,
    UpdateFlightDeparturesParams,
} from './types/flight-departures'

type ApiGetFlightDeparturesResponse = Promise<AxiosResponse<GetFlightDeparturesResponse>>
type ApiCreateFlightDeparturesResponse = Promise<AxiosResponse<void>>
type ApiUpdateFlightDeparturesResponse = Promise<AxiosResponse<void>>
type ApiExportExcelResponse = Promise<AxiosResponse<FlightDeparturesExportExcelResponse>>

export function getList(params: GetFlightDeparturesParams): ApiGetFlightDeparturesResponse {
    return http.get('/cabinet/api/flight-departures', { params })
}

export function createFlightDeparture(payload: FormData): ApiCreateFlightDeparturesResponse {
    return http.postFormData('/cabinet/api/flight-departures/import', payload)
}

export function updateFlightDeparture(
    id: number,
    payload: UpdateFlightDeparturesParams
): ApiUpdateFlightDeparturesResponse {
    return http.put(`/cabinet/api/flight-departures/${id}`, payload)
}

export function exportExcel(params: FlightDeparturesExportExcelParams): ApiExportExcelResponse {
    return http.get('/cabinet/api/flight-departures/export', { responseType: 'blob', params })
}

export default {
    getList,
    createFlightDeparture,
    updateFlightDeparture,
    exportExcel,
}
